import apiService from './api';

class ContactService {
  // Contact form submission
  async submitContactForm(formData) {
    try {
      const response = await apiService.post('/contact/submit', formData);
      return response;
    } catch (error) {
      console.error('Contact form submission error:', error);
      throw error;
    }
  }

  // Get all messages (Admin only)
  async getMessages(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.isRead !== undefined) queryParams.append('isRead', params.isRead);

      const queryString = queryParams.toString();
      const endpoint = `/contact/messages${queryString ? `?${queryString}` : ''}`;
      
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Get messages error:', error);
      throw error;
    }
  }

  // Get message by ID (Admin only)
  async getMessageById(id) {
    try {
      const response = await apiService.get(`/contact/messages/${id}`);
      return response;
    } catch (error) {
      console.error('Get message by ID error:', error);
      throw error;
    }
  }

  // Update message status (Admin only)
  async updateMessageStatus(id, statusData) {
    try {
      const response = await apiService.put(`/contact/messages/${id}/status`, statusData);
      return response;
    } catch (error) {
      console.error('Update message status error:', error);
      throw error;
    }
  }

  // Delete message (Admin only)
  async deleteMessage(id) {
    try {
      const response = await apiService.delete(`/contact/messages/${id}`);
      return response;
    } catch (error) {
      console.error('Delete message error:', error);
      throw error;
    }
  }

  // Get contact statistics (Admin only)
  async getContactStats() {
    try {
      const response = await apiService.get('/contact/stats');
      return response;
    } catch (error) {
      console.error('Get contact stats error:', error);
      throw error;
    }
  }

  // Validate contact form data
  validateContactForm(formData) {
    const errors = {};

    // Required fields validation
    if (!formData.firstName || formData.firstName.trim() === '') {
      errors.firstName = 'Ad alanı zorunludur';
    }

    if (!formData.lastName || formData.lastName.trim() === '') {
      errors.lastName = 'Soyad alanı zorunludur';
    }

    if (!formData.email || formData.email.trim() === '') {
      errors.email = 'E-posta alanı zorunludur';
    } else {
      // Email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = 'Geçerli bir e-posta adresi giriniz';
      }
    }

    if (!formData.message || formData.message.trim() === '') {
      errors.message = 'Mesaj alanı zorunludur';
    }

    // Phone number validation (optional)
    if (formData.phoneNumber && formData.phoneNumber.trim() !== '') {
      const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
      if (!phoneRegex.test(formData.phoneNumber)) {
        errors.phoneNumber = 'Geçerli bir telefon numarası giriniz';
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  // Format form data for API submission
  formatContactFormData(formData) {
    return {
      firstName: formData.firstName?.trim() || '',
      lastName: formData.lastName?.trim() || '',
      email: formData.email?.trim().toLowerCase() || '',
      companyName: formData.companyName?.trim() || null,
      phoneNumber: formData.phoneNumber?.trim() || null,
      message: formData.message?.trim() || ''
    };
  }
}

// Create and export contact service instance
const contactService = new ContactService();
export default contactService;
